var React = require('react');

function Christian (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.7151 57.5774C33.505 67.1231 47.7984 72.1688 61.0516 72.1688C81.218 72.1688 101.338 60.5148 115.953 46.5168L148.832 80L155.294 73.5281L122.371 40.0006L155.294 6.47193L148.832 0L115.953 33.4832C101.336 19.484 81.2216 7.83117 61.0516 7.83117C47.7984 7.83117 33.5038 12.8769 19.7151 22.4226C9.43456 29.5395 3.03783 36.6157 2.77125 36.9136L0 40.0006L2.77125 43.0864C3.03783 43.3843 9.43456 50.4617 19.7151 57.5774ZM61.0516 17.0228C82.9407 17.0228 102.242 33.1027 109.518 40.0054C102.259 46.9105 83.0047 62.9784 61.0516 62.9784C39.1612 62.9784 19.8584 46.8949 12.5861 39.9958C19.8454 33.0907 39.0984 17.0228 61.0516 17.0228Z","fill":"black"}));
}

Christian.defaultProps = {"width":"156","height":"80","viewBox":"0 0 156 80","fill":"none"};

module.exports = Christian;

Christian.default = Christian;
